import Vue from 'vue';
import CreateSubscriptionContractRequestModel from '../../generated/types/model/resource/CreateSubscriptionContractRequestModel';
import RequestSummaryResourceViewModel from './RequestSummaryResourceViewModel';
import utils from '../utils';
import RequestSummaryItemResourceViewModel from './RequestSummaryItemResourceViewModel';

export default class CreateSubscriptionContractRequestViewModel extends CreateSubscriptionContractRequestModel {
  protected transformToDTO() {
    this.dto.summary = this.summary.getDTO();
  }
  protected transformFromDTO() {}

  get summary(): RequestSummaryResourceViewModel {
    return new RequestSummaryResourceViewModel().fromDTO({
      sections: [
        {
          title: Vue.$t('memberPortal.subscription.label.stepTitles.1'),
          items: [
            {
              label: Vue.$t('form.address.language'),
              displayValue: this.languageIso2?.toUpperCase(),
            },
            ...this.orderBasket.items.map((item : any) => ({
              label: item.caption!,
              displayValue: Vue.$format.currency(item.grossPrice!, item.currency as any ?? 'CHF'),
            })),
          ],
        },
        {
          title: Vue.$t('memberPortal.subscription.label.stepTitles.2'),
          items: [
            ...this.billingContact.address.getSummaryItems({ hideLanguageIso2: true }),
          ],
        },
        {
          title: Vue.$t('memberPortal.subscription.label.stepTitles.3'),
          items: [
            {
              label: Vue.$t('memberPortal.subscription.label.hasDifferentDeliveryAddress'),
              displayValue: this.deliveryContact.isDifferentFromOwner ? Vue.$t('app.yes') : Vue.$t('app.no'),
            },
            ...utils.insertIf(
              this.deliveryContact.isDifferentFromOwner!,
              this.deliveryContact.address.getSummaryItems({ hideLanguageIso2: true }),
              [],
            ),
          ],
        },
        {
          title: Vue.$t('memberPortal.subscription.label.stepTitles.4'),
          items: [
            {
              label: Vue.$t('memberPortal.createMembership.label.paymentMethod'),
              displayValue: this.orderBasket.paymentMethod === 1 ? Vue.$t('memberPortal.createMembership.label.perBill') : Vue.$t('memberPortal.createMembership.label.online'),
            },
            new RequestSummaryItemResourceViewModel().fromModel({
              ...utils.insertIf(this.subscriptionType === 2, {
                label: Vue.$t('memberPortal.gastroJournal.label.newsletter'),
                displayValue: this.newsletter ? Vue.$t('app.yes') : Vue.$t('app.no'),
              }),
            }),
          ],
        },
      ].map((section) => ({
        ...section,
        items: section?.items?.filter((item: any) => item.label !== undefined && item.displayValue !== undefined && item.displayValue !== null) ?? [],
      })),
    });
  }
}
